// src/Components/RouteList.jsx
import React from 'react';
import styles from '../Pages/TravelManagement.module.css';

const RouteList = React.memo(({ routes, terminalOptions, onEdit, onDelete }) => {

  if (!routes || routes.length === 0) {
    return (
      <p className={styles.emptyMessage}>No hay rutas registradas con estos filtros.</p>
    );
  }

  // Función de ayuda para formatear fecha y hora
  const formatDateTime = (dateString) => {
    if (!dateString) return '—';
    const date = new Date(dateString);
    const dateStr = date.toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit', year: 'numeric' });
    const timeStr = date.toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit' });
    return `${dateStr} ${timeStr}`;
  };

  return (
    <div className={styles.tableContainer}>
      <table className={styles.routeTable}>
        <thead>
          <tr>
            <th>Fecha/Hora Salida</th>
            <th>Origen → Destino</th>
            <th>Duración</th>
            <th>Distancia</th>
            <th>Bus</th>
            <th>Precio</th>
            <th className={styles.actionsHeader}>Acciones</th>
          </tr>
        </thead>
        <tbody>
          {routes.map(route => (
            <tr key={route.ID} className={styles.routeTableRow}>
              <td>{formatDateTime(route.Departure_date)}</td>
              <td>
                <span className={styles.origin}>{route.Origin}</span> → <span className={styles.destination}>{route.Destination}</span>
              </td>
              <td>{route.Duration}h</td>
              <td>{route.Distance} km</td>
              <td>{route.Bus_Plate || `Bus #${route.ID_Bus}`}</td>
              <td>${route.Price}</td>
              <td className={styles.actionsCell}>
                <button
                  onClick={() => onEdit(route)}
                  className={styles.buttonEdit}
                >
                  Editar
                </button>
                <button
                  onClick={() => onDelete(route.ID)}
                  className={styles.buttonDeactivate}
                >
                  Desactivar
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
});

export default RouteList;